// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19bvxy5q{padding-left:var(--ds-space-400,2pc)}\n._19pkpxbi{margin-top:var(--ds-space-200,1pc)}\n._1bah1h6o{justify-content:center}\n._1e0c1txw{display:flex}\n._1tkeuuw1{min-height:200px}\n._4cvr1h6o{align-items:center}\n._ca0qxy5q{padding-top:var(--ds-space-400,2pc)}\n._n3tdxy5q{padding-bottom:var(--ds-space-400,2pc)}\n._u5f3xy5q{padding-right:var(--ds-space-400,2pc)}", ""]);
// Exports
module.exports = exports;
